import { Link } from "react-router-dom"
import { PLAN_STATUS_LABELS } from "../../constants/planStatusBadges"

const ActivityFeed = ({ activities }) => {
  if (!activities || activities.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Recent Activity</h2>
        <p className="text-sm text-gray-500 text-center py-8">No recent activity</p>
      </div>
    )
  }

  const getStatusIcon = (type) => {
    switch (type) {
      case 'plan_status_change':
        return 'fa-arrow-right'
      case 'user_created':
        return 'fa-user-plus'
      case 'plan_created':
        return 'fa-plus'
      default:
        return 'fa-circle'
    }
  }

  const getStatusColor = (type) => {
    switch (type) {
      case 'plan_status_change':
        return 'bg-brand'
      case 'user_created':
        return 'bg-circle'
      case 'plan_created':
        return 'bg-gifts'
      default:
        return 'bg-gray-500'
    }
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Recent Activity</h2>
      <div className="space-y-3">
        {activities.map((activity, index) => (
          <div
            key={index}
            className="flex items-start gap-3 p-3 hover:bg-gray-50 rounded-lg transition-colors"
          >
            <div className={`flex-shrink-0 w-8 h-8 rounded-full ${getStatusColor(activity.type)} bg-opacity-10 flex items-center justify-center`}>
              <i className={`fa ${getStatusIcon(activity.type)} ${getStatusColor(activity.type).replace('bg-', 'text-')} text-sm`}></i>
            </div>
            <div className="flex-1 min-w-0">
              {activity.type === 'plan_status_change' && (
                <>
                  <p className="text-sm text-gray-900">
                    {activity.plan_token ? (
                      <Link
                        to={`/admin/plans/${activity.plan_token}`}
                        className="font-semibold text-brand hover:underline"
                      >
                        {activity.plan_name}
                      </Link>
                    ) : (
                      <span className="font-semibold">{activity.plan_name}</span>
                    )}{' '}
                    progressed to{' '}
                    <span className="font-semibold">
                      {PLAN_STATUS_LABELS[activity.to_status] || activity.to_status}
                    </span>
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {activity.changed_by && `by ${activity.changed_by.name} • `}
                    {activity.formatted_date}
                  </p>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ActivityFeed
